import { useState } from 'react'

import Http from '@shared/http'

export const RequestStatus = {
  ready: 'ready',
  loading: 'loading',
  error: 'error',
  success: 'success'
}

export default function useHTTPRequest({
  url,
  method = 'GET',
  options = {},
  followRedirects = false,
  onStart,
  onSuccess,
  onError,
  onComplete
}) {
  const [requestStatus, setRequestStatus] = useState(RequestStatus.ready)
  const ready = requestStatus === RequestStatus.ready
  const loading = requestStatus === RequestStatus.loading
  const success = requestStatus === RequestStatus.success
  const error = requestStatus === RequestStatus.error
  const complete = error || success
  const [state, setState] = useState()
  const reset = ({ resetState = true }) => {
    resetState && setState(undefined)
    setRequestStatus(RequestStatus.ready)
  }

  const request = async (data = {}) => {
    onStart && onStart()
    setRequestStatus(RequestStatus.loading)
    const body = JSON.stringify(data)
    let responseBody

    try {
      const response = await Http.request(url, method, body, followRedirects ? 'follow' : 'manual', options)

      if (response.redirected && followRedirects) {
        window.location.href = response.url
        return
      }

      if (response.ok) {
        try {
          responseBody = await response.json()
          onSuccess && onSuccess(responseBody)
          setState(responseBody)
          setRequestStatus(RequestStatus.success)
        } catch (error) {
          // The HTTP response body (JSON) could not be parsed
          setRequestStatus(RequestStatus.error)
          onError && onError(error)
        }
      } else {
        // The HTTP response was returned with a non-2xx status code
        setRequestStatus(RequestStatus.error)
        onError && onError()
      }
    } catch (error) {
      // Something else went wrong
      setRequestStatus(RequestStatus.error)
      onError && onError(error)
    }

    onComplete && onComplete(responseBody)
    return responseBody
  }

  return {
    execute: request,
    status: requestStatus,
    state,
    reset,

    /* Status indicator convenience flags */
    ready,
    loading,
    success,
    error,
    complete
  }
}
